var React = require('react');

function MailInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M60 0H452C485.084 0 512 26.916 512 60V316C512 349.084 485.084 376 452 376H60C26.916 376 0 349.084 0 316V60C0 26.916 26.916 0 60 0ZM452 336C463.028 336 472 327.028 472 316V60C472 48.972 463.028 40 452 40H60C48.972 40 40 48.972 40 60V316C40 327.028 48.972 336 60 336H452Z","fill":"white","key":0}),React.createElement("path",{"d":"M468.604 24.937L256 183.074L43.396 24.937L19.522 57.032L256 232.926L492.478 57.032L468.604 24.937Z","fill":"white","key":1})]);
}

MailInline.defaultProps = {"width":"512","height":"376","viewBox":"0 0 512 376","fill":"none"};

module.exports = MailInline;

MailInline.default = MailInline;
